import { useNavigate } from 'react-router-dom';
import { usePermissions } from '../../../../hooks/usePermissions';
import { useSpacePath } from '../../../../hooks/useSpacePath';
import { OpenPendingItemWithSubTopic } from '../../../../types';
import { useUpdatePendingItem } from '../../api/useUpdatePendingItem';

type Props = {
  item: OpenPendingItemWithSubTopic;
};

export function useOpenPendingItem(props: Props) {
  const { isAdmin } = usePermissions();
  const spacePath = useSpacePath();
  const navigate = useNavigate();
  const { mutate: updateItem } = useUpdatePendingItem(props.item.subject_id);

  const targetUrl = props.item.sub_topics?.id
    ? spacePath(`/topics/${props.item.sub_topics.id}`)
    : undefined;

  function handleToggle(completed: boolean) {
    updateItem({
      id: props.item.id,
      state: completed ? 'completed' : 'pending',
      completed_at: completed ? new Date().toISOString() : null,
    });
  }

  function handleSubTopicClick(event?: React.MouseEvent<HTMLAnchorElement | HTMLElement>) {
    if (
      !targetUrl ||
      !event ||
      event.defaultPrevented ||
      event.button !== 0 ||
      event.metaKey ||
      event.altKey ||
      event.ctrlKey ||
      event.shiftKey
    ) {
      return;
    }
    event.preventDefault();
    navigate(targetUrl);
  }

  return {
    isAdmin,
    targetUrl,
    handleToggle,
    handleSubTopicClick,
  };
}
